var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "check-result-display" }, [
    _c("img", {
      class: _vm.currentState == "checking" ? "animate" : "",
      attrs: { src: _vm.icon }
    }),
    _c("div", { staticClass: "status-text" }, [_vm._v(_vm._s(_vm.lbStatus))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }